import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { ValidationDashboardUrl } from './ValidationDashboardUrl';

const postVisualValidationCrosstable = (data: {
  dataObjectVersionId: number;
}) =>
  apiClient
    .post<{ externalCode: string }>(ValidationDashboardUrl.CROSSTABLE, data)
    .then((response) => response.data);

export const useGenerateVisualValidationCrosstableMutation =
  createApiMutationHook(
    ['visualValidationCrosstable'],
    postVisualValidationCrosstable,
  );
